var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "modal",
    staticClass: "price-form",
    attrs: {
      "playground": "",
      "title": _vm.$t('title')
    },
    on: {
      "hidden": _vm.onHidden,
      "shown": _vm.focusPrimaryInput
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "uk-modal-body"
  }, [_c('validation-alert-box', {
    attrs: {
      "errors": _vm.fields.errors.base
    }
  }), _vm._v(" "), _c('organization-combobox', {
    attrs: {
      "label": _vm.$t('fields.organization'),
      "errors": _vm.fields.errors.organization,
      "placeholder": _vm.$t('placeholders.defaultOrganization'),
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.organization),
      callback: function($$v) {
        _vm.fields.values.organization = $$v
      },
      expression: "fields.values.organization"
    }
  }), _vm._v(" "), _c('radio-group-input', {
    attrs: {
      "label": _vm.$t('fields.type'),
      "errors": _vm.fields.errors.type,
      "collection": _vm.availablePriceTypes,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.type),
      callback: function($$v) {
        _vm.fields.values.type = $$v
      },
      expression: "fields.values.type"
    }
  }), _vm._v(" "), _c('radio-group-input', {
    attrs: {
      "label": _vm.$t('fields.paymentFrequency'),
      "errors": _vm.fields.errors.paymentFrequency,
      "collection": _vm.availablePaymentFrequencies,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.paymentFrequency),
      callback: function($$v) {
        _vm.fields.values.paymentFrequency = $$v
      },
      expression: "fields.values.paymentFrequency"
    }
  }), _vm._v(" "), _c('money-input', {
    ref: "primaryInput",
    staticClass: "uk-width-1-4",
    attrs: {
      "label": _vm.$t('fields.value'),
      "size": "large",
      "errors": _vm.fields.errors.value,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.value),
      callback: function($$v) {
        _vm.fields.values.value = _vm._n($$v)
      },
      expression: "fields.values.value"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer uk-text-right"
  }, [_c('submit-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isSubmittable
    }
  }), _vm._v(" "), _c('common-button', {
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('actions.cancel')) + "\n      ")])], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50e5be7c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/PriceForm.vue
// module id = 1983
// module chunks = 0